// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
  height: 200px;
}
.modal-container__body--category {
  margin-top: 20px;
}
.modal-container__body--select {
  width: 100% !important;
}
.modal-container__body--comment {
  margin-top: 20px;
}
.modal-container__body--button {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/containers/Reports/ReopenLead/styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAEQ;EACI,gBAAA;AAAZ;AAEQ;EACI,sBAAA;AAAZ;AAEQ;EACI,gBAAA;AAAZ;AAEQ;EACI,gBAAA;AAAZ","sourcesContent":[".modal-container{\n    height: 200px;\n\n    &__body{\n        &--category{\n            margin-top: 20px\n        }\n        &--select{\n            width: 100% !important;\n        }\n        &--comment{\n            margin-top: 20px\n        }\n        &--button{\n            margin-top: 20px\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
